'use strict';

var defaults = require('../../defaults/Defaults');
var FileDownloader = require('./FileDownloader');
var log = require('../../log/Log').channel('UpdateController');
var sutl = require('../../sutl/Sutl');
require('./DeviceService');
require('./RoomService');
require('./SharedPrefs');

/* global AveoPackageReplaced */

angular.module('inara').controller('UpdateController', UpdateController);

UpdateController.$inject = ['$scope', '$state', '$q', '$timeout',
    'ControllerService', 'DeviceService', 'RoomService', 'SharedPrefs',
    'gettextCatalog'];

function UpdateController($scope, $state, $q, $timeout, ControllerService,
    DeviceService, RoomService, SharedPrefs, gettextCatalog) {
    var vm = this;

    log.info('initializing');
    /// Status message for Mira Connect automatic updates
    vm.message = gettextCatalog.getString('Checking for {{inaraName}} updates...',
        { inaraName: defaults.inara.name });
    vm.progress = 0;
    vm.getViewTitle = function() {
        /// Title bar for Mira Connect automatic update page
        return gettextCatalog.getString('{{inaraName}} Updating', { inaraName: defaults.inara.name });
    };

    $scope.$on('$stateChangeSuccess', onStateChange);

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (fromState.name !== 'update' && toState.name === 'update') {
            return $q.resolve()
            .then(DeviceService.cleanUpFiles)
            .then(doUpdates)
            .then(function() {
                if (RoomService.isControllerLoaded &&
                    sutl.getNode(RoomService.getController(),
                        [ 'settings', 'factoryInstallMode' ])) {
                    $state.go('factoryInstall');
                } else {
                    $state.go('start');
                }
            });
        }
    }

    function doUpdates() {
        var updates = ControllerService.getUpdates();
        var p = $q.resolve();
        var restartPackages = [];
        var restarted = false;

        vm.progress = 0;

        var updateFunctions = {
            'knoxAnimations': updateKnoxAnimations,
            'file': updateFile,
            'sharedPrefs': updateSharedPrefs,
            'apk': updateApk,
            'uninstallApk': uninstallApk,
            'systemUpdate': updateSystem,
        };

        updates.forEach(function(update) {
            if (update.type === 'apk' && update.restart) {
                log.debug('registering package ' + update.packageName + ' for restart');
                restartPackages.push(update.packageName);
            }
        });

        p = p.then(function() {
            return AveoPackageReplaced.registerPackages(restartPackages);
        });

        updates.forEach(function(update, index) {
            log.info('doing ' + update.name + ' update');

            /// Status message for Mira Connect automatic updates.
            vm.message = gettextCatalog.getString('Updating {{inaraName}} ({{current}}/{{total}})...',
                { inaraName: defaults.inara.name, current: index + 1, total: updates.length });

            if (updateFunctions.hasOwnProperty(update.type)) {
                if (!restarted) {
                    p = p.then(function() {
                        return updateFunctions[update.type](update, index, updates.length);
                    });

                    if (update.restart) restarted = true;
                }
            } else {
                log.error('unrecognized update type for ' +
                    JSON.stringify(update, null, 4));
            }

            p = p.then(function() {
                vm.progress = Math.round(100 * (index + 1) / updates.length);
            });
        });

        p = p.then(function() {
            return DeviceService.finishUpdates(updates);
        });

        return p;
    }

    function uninstallApk(update) {
        log.info('uninstalling ' + update.packageName);

        return DeviceService.uninstallApplication(update)
        .then(function() {
            log.info('uninstalled ' + update.packageName);
        }, function(err) {
            log.error('failed uninstalling ' + update.packageName + ', error: ' + err);
            return $q.resolve();
        });
    }

    function updateApk(update, index, numUpdates) {
        return $q(function(resolve, reject) {
            $timeout(function() { resolve(); }, 200);
        })
        .then(function() {
            log.info('updating ' + update.name + ' apk');
            return DeviceService.updateApplication(update, function(prog) {
                vm.progress = Math.round(100 * (index + prog) / numUpdates);
            });
        })
        .then(function() {
            log.info('successfully updated ' + update.name + ' apk');
        }, function(err) {
            log.error('failed updating ' + update.name + ' apk, error: ' + err);
            return $q.resolve();
        })
        .then(function() {
            if (update.hasOwnProperty('deviceAdmin')) {
                var controller = RoomService.getController();

                if (controller !== null &&
                    controller.settings.factoryInstallMode) {
                    log.info('enabling device admin for ' +
                        update.deviceAdmin.packageName + '.' +
                        update.deviceAdmin.className);
                    return DeviceService.enableDeviceAdminForComponent(
                        update.deviceAdmin.packageName,
                        update.deviceAdmin.className);
                } else {
                    log.debug('not in factory install mode, ' +
                        'so skipping enabling of device admin for ' +
                        update.deviceAdmin.packageName + '.' +
                        update.deviceAdmin.className);
                }
            }
        })
        .then($q.resolve, $q.resolve);
    }

    function updateFile(update, index, numUpdates) {
        return FileDownloader.download(
            update.fileUri, cordova.file[update.destRoot] + update.dest, function(prog) {
                vm.progress = Math.round(100 * (index + prog) / numUpdates);
            }
        )
        .then(function() {
            log.info('successfully downloaded ' + update.name + ' file');
            return SharedPrefs.setInt(update.versionKey, update.version);
        })
        .then($q.resolve, $q.reject);
    }

    function updateKnoxAnimations(update, index, numUpdates) {
        log.info('updating knox animations');

        return DeviceService.updateKnoxAnimations(update, function(prog) {
            vm.progress = Math.round(100 * (index + prog) / numUpdates);
        })
        .then(function() {
            log.info('successfully updated knox animations');
        }, function(err) {
            log.error('failed updating knox animations, error: ' + err);
            return $q.resolve();
        })
        .then(function() {
            return SharedPrefs.setInt(update.versionKey, update.version);
        })
        .then($q.resolve, $q.resolve);
    }

    function updateSharedPrefs(update) {
        var sharedPrefsPromises = [];

        for (var prefName in update.settings) {
            if (!update.settings.hasOwnProperty(prefName)) continue;
            var pref = update.settings[prefName];

            if (pref.type === 'boolean') {
                sharedPrefsPromises.push(
                    SharedPrefs.setBoolean(prefName, pref.value,
                        update.packageName, update.prefsFileName));
            } else if (pref.type === 'float') {
                sharedPrefsPromises.push(
                    SharedPrefs.setFloat(prefName, pref.value,
                        update.packageName, update.prefsFileName));
            } else if (pref.type === 'int') {
                sharedPrefsPromises.push(
                    SharedPrefs.setInt(prefName, pref.value,
                        update.packageName, update.prefsFileName));
            } else if (pref.type === 'long') {
                sharedPrefsPromises.push(
                    SharedPrefs.setLong(prefName, pref.value,
                        update.packageName, update.prefsFileName));
            } else if (pref.type === 'string') {
                sharedPrefsPromises.push(
                    SharedPrefs.setString(prefName, pref.value,
                        update.packageName, update.prefsFileName));
            } else if (pref.type === 'set') {
                var setValues = [];

                for (var key in pref.values) {
                    if (!pref.values.hasOwnProperty(key)) continue;
                    setValues.push(pref.values[key]);
                }

                sharedPrefsPromises.push(
                    SharedPrefs.setStringSet(prefName, setValues,
                        update.packageName, update.prefsFileName));
            }
        }

        return $q.all(sharedPrefsPromises)
        .then(function() {
            return SharedPrefs.setInt(update.versionKey, update.version);
        })
        .then($q.resolve, $q.resolve);
    }

    function updateSystem(update, index, numUpdates) {
        return DeviceService.updateSystem(update, function(prog) {
            vm.progress = Math.round(100 * (index + prog) / numUpdates);
        });
    }
}

module.exports = UpdateController;
